<template>
    <div>
        <div class="head p20 w100" style="box-sizing: border-box; position:absolute;">
            <el-row>
                <el-col :span="8">
                    <div class="grid-content head-left fontWhite">
                        <router-link to="/*"><img src="../assets/images/logo.png" alt=""></router-link>
                        <span class="inlineBlock vTop font14 pointer" v-show="!isLogin" @click="showLoginDialog()">注册/登录</span>
                        <span class="inlineBlock vTop font14" v-show="isLogin">{{ userInfoAll.username }}</span>
                        <router-link to="/home/selfPage" class="inlineBlock vTop font14 pointer fontWhite" v-show="isLogin">会员中心</router-link>
                    </div>
                </el-col>
                <el-col :span="16">
                    <div class="grid-content head-right">
                        <ul>
                            <li class="floatLeft" v-for="(item, index) in navigation_level" :key="index">
                                <router-link v-if="item.isVaild == 'Y'" class="fontWhite font16 block textCenter bottom-menu" :to="item.navigationUrl == '/home/videoList' ||item.navigationUrl == '/serviceSystem' || item.navigationUrl == '/home/quote' || item.navigationUrl == '/home/tradeNews' || item.navigationUrl == '/home/activities' ? item.navigationUrl : (item.navigationUrl + '/' + item.navigationId)">{{ item.navigationName }}</router-link>
                            </li>
                        </ul>
                    </div>
                </el-col>
            </el-row>
        </div>
        <Login ref="loginDialog"></Login>
    </div>
</template>

<script>
    import $ from 'jquery'
    import '../assets/js/gVerify'
    import { mw_validate, baseUrl } from '../assets/js/common'
    import Login from '../templates/loginControl'
    export default {
        name: 'Header2',
        components: { Login },
        data () {
            return {
                isLogin: false,
                userInfoAll: {},
                navigation_level: []

            }
        },
        mounted () {
            // 初始化内容
            this.getUserInfo()
        },
        methods: {
            /* 获取cookies */
            getUserInfo () {
                const self = this;
                const token_cyw = self.$cookies.get('token_cyw');
                if (token_cyw) {
                    self.getUserAllInfo(token_cyw);
                } else {
                    self.isLogin = false;
                    self.findNaTree('N');
                }
            },
            /* 获取用户全部信息 */
            getUserAllInfo (token_cyw, type) {
                const self = this;
                self.$get(`${baseUrl.business}/api/user/userByToken/${token_cyw}`, {}).then(res_1 => {
                    if (res_1.status == 200) {
                        self.$get(`${baseUrl.business}/api/user/find/${res_1.data.id}`, {}).then(res => {
                            if(res.status == 200) {
                                if (res.data == null) {
                                    self.$message.error('未获取到身份信息')
                                } else {
                                    self.userInfoAll = res.data;
                                    self.isLogin = true;
                                    self.findNaTree('Y');
                                    if (type) {
                                        self.updateLoginUser(); // 获取到用户身份信息后调用
                                    }
                                }
                            } else {
                                self.$message.error(res.message)
                                self.isLogin = false;
                            }
                        }).catch(err => {
                            self.$message.error('未获取到身份信息');
                        })
                    } else {
                        self.$message.error(res_1.msg);
                        self.$cookies.remove('token_cyw');
                        self.$route.go(0);
                    }
                }).catch(err_1 => {
                    self.$message.error('请求错误');
                })
                
            },
            findNaTree (visit) { // 菜单
                const self = this;
                self.$get(`${baseUrl.cyw}/navigation/findNaTree?visitLimit=${'Y'}`, {}).then(res => {
                    if (res.code == 0) {
                        self.navigation_level = res.data.reverse();
                    } else {
                        self.$message.error(res.message);
                    }
                }).catch(err => {
                    self.$message.error('未获取到导航信息');
                })
            },
/* **********************************登录 ***********************************************/
            showLoginDialog () { // 点击显示弹框
                this.$refs.loginDialog.init();
            },
/* **********************************登录 ***********************************************/

/* **************** 记录点击 *** */
            updateLoginUser () {
                const self = this;
                self.$get(`${baseUrl.crm}/business/cyw/openapi/updateLoginUserVistNumAndLoginTime.json?id=${self.userInfoAll.crmUserId}`, {}).then(res => {
                    this.$router.go(0); 
                })
            },
/* **************** 记录点击 *** */

        },
    }
</script>

<style scoped>
    .head { background: rgba(0, 0, 0, 0.2); z-index: 9999;}
    .head .head-left img { height: 65px; margin-right: 10px; }
    .head .head-left span, .head .head-left a { margin-left: 10px; margin-right: 10px; margin-top: 25px; }
    .head .head-right ul { margin-top: 25px; }
    .head .head-right li { float: right; }
    .head .head-right li a { display: block; width: 80px; text-align: center; color: #ffffff; }
    .head .head-right li a:hover,
    .head .head-right li a.active { color: #a30000 }
    
    .login-code { border-right: 1px solid #f6f6f6; }
    .login-code img { width: 180px; }
    .login-code p { line-height: 26px; }
    .login-form, .top .login-code { padding: 40px; }
    .login-form .check-code .code-before { border: 1px solid #f6f6f6; height: 30px; line-height: 30px; width: 102px; position: relative; }
    .login-form .check-code .code-after { border: 1px solid #f6f6f6; border-radius: 5px; width: 65px; height: 30px; margin-left: 5px; margin-right: 5px;}
    .dialog-footer > div { height: 30px; line-height: 30px; }
    .login-improve .type-box { border: 1px solid #eee; padding: 0 15px; margin-top: 10px; }
</style>